function leadZero(n, targetLength) {
    if (targetLength === void 0) { targetLength = 2; }
    var output = n + '';
    while (output.length < targetLength) {
        output = '0' + output;
    }
    return output;
}
function absFloor(num) {
    if (num < 0) {
        // -0 -> 0
        return Math.ceil(num) || 0;
    }
    else {
        return Math.floor(num);
    }
}
function extend(obj1, obj2) {
    var result = {};
    for (var key in obj1) {
        result[key] = obj1[key];
    }
    for (var key in obj2) {
        result[key] = obj2[key];
    }
    return result;
}
function tokensRx(obj) {
    var keys = [];
    for (var key in obj) {
        keys.push(key);
    }
    keys.sort(function (a, b) { return b.length - a.length; });
    return new RegExp(keys.join('|') + '|\\[[^[]*\\]|.', 'g');
}
function formatTimezone(offset, delimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + leadZero(hours) + delimiter + leadZero(minutes);
}

/**
 * Adds a number of milliseconds to date
 */
function addMilliseconds(date, milliseconds) {
    if (date === null)
        return null;
    if (!isFinite(milliseconds))
        return date;
    return new Date(date.getTime() + milliseconds);
}
/**
 * Adds a number of seconds to date
 */
function addSeconds(date, seconds) {
    if (date === null)
        return null;
    if (!isFinite(seconds))
        return date;
    return new Date(date.getTime() + 1000 /* MS.Seconds */ * seconds);
}
/**
 * Adds a number of minutes to date
 */
function addMinutes(date, minutes) {
    if (date === null)
        return null;
    if (!isFinite(minutes))
        return date;
    return new Date(date.getTime() + 60000 /* MS.Minutes */ * minutes);
}
/**
 * Adds a number of hours to date
 */
function addHours(date, hours) {
    if (date === null)
        return null;
    if (!isFinite(hours))
        return date;
    return new Date(date.getTime() + 3600000 /* MS.Hours */ * hours);
}
/**
 * Adds a number of days to date
 */
function addDate(date, days) {
    if (date === null)
        return null;
    if (!isFinite(days))
        return date;
    var result = new Date(date.getTime());
    result.setDate(result.getDate() + days);
    return result;
}
/**
 * Adds a number of months to date
 */
function addMonth(date, months) {
    if (date === null)
        return null;
    if (!isFinite(months))
        return date;
    var result = new Date(date.getTime());
    result.setMonth(result.getMonth() + months);
    return result;
}
/**
 * Adds a number of years to date
 */
function addYear(date, years) {
    if (date === null)
        return null;
    if (!isFinite(years))
        return date;
    var result = new Date(date.getTime());
    result.setFullYear(result.getFullYear() + years);
    return result;
}

var START_OF_ISO_WEEK = 1;
function resetYear(d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), 0);
}
function resetMonth(d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), d.getMonth(), 1);
}
function resetISOWeek(d) {
    if (d === null)
        return null;
    var day = d.getDay();
    var diff = (day < START_OF_ISO_WEEK ? 7 : 0) + day - START_OF_ISO_WEEK;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - diff);
}
function resetDate(d) {
    if (d === null)
        return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
function resetHours(d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setMinutes(0, 0, 0);
    return result;
}
function resetMinutes(d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setSeconds(0, 0);
    return result;
}
function resetSeconds(d) {
    if (d === null)
        return null;
    var result = new Date(d.getTime());
    result.setMilliseconds(0);
    return result;
}

/**
 * Type guard for ValidDate
 */
function isValidDate(d) {
    return d !== null && d instanceof Date && isFinite(d.getTime());
}
/**
 * Converts to the `ValidDate`, creating new instance of Date
 * @deprecated consider use of `isValidDate`
 */
function fromDate(date) {
    var d = new Date(+date);
    return asValidDateOrNull(d);
}
/**
 * Converts to the `ValidDate`, creating new instance of Date
 * @throws Will throw TypeError if input not a valid Date or timestamp
 * @deprecated Consider use of `isValidDate`
 */
function fromDateOrThrow(date) {
    var d = new Date(date instanceof Date ? date.getTime() : date);
    return asValidDateOrThrow(d, date);
}
function asValidDateOrNull(date) {
    if (isValidDate(date))
        return date;
    return null;
}
function asValidDateOrThrow(date, origin) {
    if (isValidDate(date))
        return date;
    throw new TypeError("Cant parse date from \"".concat(origin, "\""));
}
function newValidDate() {
    var dateArgs = [undefined];
    for (var i = 0; i < arguments.length; i++) {
        dateArgs[i + 1] = arguments[i];
    }
    var result = new (Date.bind.apply(Date, dateArgs))();
    return asValidDateOrNull(result);
}
function newValidDateOrThrow() {
    var dateArgs = [undefined];
    for (var i = 0; i < arguments.length; i++) {
        dateArgs[i + 1] = arguments[i];
    }
    var result = new (Date.bind.apply(Date, dateArgs))();
    return asValidDateOrThrow(result, dateArgs);
}

/**
 * The number of milliseconds between two dates
 * @example
 * diffMilliseconds(parseIso('2020-01-02'), parseIso('2020-01-01')) // 86400000 = milliseconds in one day
 */
function diffMilliseconds(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return absFloor(d1.getTime() - d2.getTime());
}
/**
 * The number of seconds between two dates
 * @example
 * diffSeconds(parseIso('2020-01-02'), parseIso('2020-01-01')) // 86400 = seconds in one day
 */
function diffSeconds(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return absFloor((d1.getTime() - d2.getTime()) / 1000 /* MS.Seconds */);
}
/**
 * The number of minutes between two dates
 * @example
 * diffMinutes(parseIso('2020-01-02'), parseIso('2020-01-01')) // 1440 = minutes in one day
 * diffMinutes(parseIso('2020-01-01T12:30:01'), parseIso('2020-01-01T12:31:00')) // 0 = only 59 seconds left
 */
function diffMinutes(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return absFloor((d1.getTime() - d2.getTime()) / 60000 /* MS.Minutes */);
}
function diffHours(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return absFloor((d1.getTime() - d2.getTime()) / 3600000 /* MS.Hours */);
}
function dateToArray(d) {
    return [
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours(),
        d.getMinutes(),
        d.getSeconds(),
        d.getMilliseconds(),
    ];
}
function compareArrays(list1, list2, fromPosition) {
    for (var i = fromPosition; i < list1.length; i++) {
        if (list1[i] === list2[i])
            continue;
        return list1[i] > list2[i] ? 1 : -1;
    }
    return 0;
}
function diffDate(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    var utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    var diff = absFloor((utc1 - utc2) / 86400000 /* MS.Date */);
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 3);
    if (diffTail === 0 || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
}
function diffMonth(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var diff = (d1.getFullYear() - d2.getFullYear()) * 12 + d1.getMonth() - d2.getMonth();
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 2);
    if (diffTail === 0 || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
}
function diffYear(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var diff = d1.getFullYear() - d2.getFullYear();
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 1);
    if (!diffTail || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
}

/**
 * Returns the number of years between two dates.
 * Months, days and time are ignored
 * @example
 * diffCalendarYear(parseIso('2020-01-01'), parseIso('2019-12-31')) // 1 = 2020 - 2019
 */
function diffCalendarYear(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return d1.getFullYear() - d2.getFullYear();
}
/**
 * Returns the number of months between two dates.
 * Days and time are ignored
 * @example
 * diffCalendarMonth(parseIso('2020-05-01'), parseIso('2020-03-31')) // 2 = 5 - 3
 */
function diffCalendarMonth(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return (d1.getFullYear() - d2.getFullYear()) * 12 + d1.getMonth() - d2.getMonth();
}
/**
 * Returns the number of days between two dates.
 * Time is ignored
 * @example
 * diffCalendarDate(parseIso('2020-05-01'), parseIso('2020-04-20')) // 11 = 10 days in april and 1 in march
 */
function diffCalendarDate(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var u1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    var u2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return absFloor((u1 - u2) / 86400000 /* MS.Date */);
}

function diffPreciseSeconds(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return (d1.getTime() - d2.getTime()) / 1000 /* MS.Seconds */;
}
function diffPreciseMinutes(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return (d1.getTime() - d2.getTime()) / 60000 /* MS.Minutes */;
}
function diffPreciseHours(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return (d1.getTime() - d2.getTime()) / 3600000 /* MS.Hours */;
}
function diffPreciseDate(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    return (d1.getTime() - d2.getTime()) / 86400000 /* MS.Date */;
}
function diffPreciseMonth(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var startOfMonth1 = +new Date(d1.getFullYear(), d1.getMonth());
    var startOfNextMonth1 = +new Date(d1.getFullYear(), d1.getMonth() + 1);
    var startOfMonth2 = +new Date(d2.getFullYear(), d2.getMonth());
    var startOfNextMonth2 = +new Date(d2.getFullYear(), d2.getMonth() + 1);
    var m1 = startOfNextMonth1 - startOfMonth1;
    var m2 = startOfNextMonth2 - startOfMonth2;
    var t1 = d1.getTime() - startOfMonth1;
    var t2 = d2.getTime() - startOfMonth2;
    /**
     * that formula was made to avoid "1 - 0.9" calculations
     * do same thing as
     * diffCalendarMonth(d1, d2) + t1 / m1 - t2 / m2
     */
    return (diffCalendarMonth(d1, d2) * m1 * m2 + t1 * m2 - t2 * m1) / (m1 * m2);
}
function diffPreciseYear(d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var startOfYear1 = +new Date(d1.getFullYear(), 0);
    var startOfNextYear1 = +new Date(d1.getFullYear() + 1, 0);
    var startOfYear2 = +new Date(d2.getFullYear(), 0);
    var startOfNextYear2 = +new Date(d2.getFullYear() + 1, 0);
    var y1 = startOfNextYear1 - startOfYear1;
    var y2 = startOfNextYear2 - startOfYear2;
    var t1 = d1.getTime() - startOfYear1;
    var t2 = d2.getTime() - startOfYear2;
    return (diffCalendarYear(d1, d2) * y1 * y2 + t1 * y2 - t2 * y1) / (y1 * y2);
}

// YYYY-MM-DD
function formatDateIso(date) {
    if (!isValidDate(date))
        return null;
    return leadZero(date.getFullYear(), 4) + '-' + leadZero(date.getMonth() + 1) + '-' + leadZero(date.getDate());
}
// YYYY-MM-DDTHH:mm
function formatDateTimeIso(date) {
    if (!isValidDate(date))
        return null;
    return formatDateIso(date) + 'T' + leadZero(date.getHours()) + ':' + leadZero(date.getMinutes());
}
// YYYY-MM-DDTHH:mm:ss.SSS
function formatLocalIso(date) {
    if (!isValidDate(date))
        return null;
    return formatDateTimeIso(date) + ':' + leadZero(date.getSeconds()) + '.' + leadZero(date.getMilliseconds(), 3);
}

function toNumber(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : +value;
}
function toNumberMs(value) {
    return typeof value === 'undefined' ? 0 : +value.substring(0, 4) * 1000;
}
var ISO_RX = /^\s*([+-]?\d{4,6}?)(?:-?(\d\d))?(?:-?(\d\d))?(?:T(\d\d):?(\d\d):?(?:(\d\d)(\.\d+)?)?([+-]\d\d?(?::\d\d)?|Z)?)?\s*$/;
//     (    YYYY     )     ( MM )       ( DD )      ( HH )  ( MM )     ( SS )(  MS )   (      TZD            )
function parseIso(dateStr) {
    if (!dateStr)
        return null;
    var timeList = dateStr.match(ISO_RX);
    if (!timeList)
        return null;
    var Y = +timeList[1];
    var M = toNumber(timeList[2], 1) - 1;
    var D = toNumber(timeList[3], 1);
    var maybeResult = new Date(Y, M, D);
    if (Y <= 99 && Y >= 0) {
        maybeResult.setFullYear(Y);
    }
    var isDateOk = maybeResult.getDate() === D && maybeResult.getMonth() === M && maybeResult.getFullYear() === Y;
    if (!isDateOk)
        return null;
    if (!timeList[4])
        return maybeResult;
    var H = toNumber(timeList[4], 0);
    var m = toNumber(timeList[5], 0);
    var s = toNumber(timeList[6], 0);
    var ms = toNumberMs(timeList[7]);
    var isTimeOk = H < 24 && m < 60 && s < 60;
    if (!isTimeOk)
        return null;
    var tzd = timeList[8];
    if (tzd === 'Z') {
        maybeResult.setUTCFullYear(Y, M, D);
        maybeResult.setUTCHours(H, m, s, ms);
    }
    else if (tzd) {
        var tzdList = tzd.split(':');
        var tzH = toNumber(tzdList[0], 0);
        var tzM = (tzd[0] === '-' ? -1 : 1) * toNumber(tzdList[1], 0);
        var isTzOk = tzH > -24 && tzH < 24 && tzM < 60;
        if (!isTzOk)
            return null;
        maybeResult.setUTCFullYear(Y, M, D);
        maybeResult.setUTCHours(H - tzH, m - tzM, s, ms);
    }
    else {
        maybeResult.setHours(H, m, s, ms);
    }
    return maybeResult;
}
function parseIsoOrThrow(dateStr) {
    var result = parseIso(dateStr);
    if (result === null)
        throw new Error("Failed to parse as ISO 8601 string: \"".concat(dateStr, "\""));
    return result;
}

function splitToTokens(template, formatters) {
    var RX_TOKENS = /*@__PURE__*/ tokensRx(formatters);
    var tokens = template.match(RX_TOKENS);
    // this regexp cant fail because of "|."
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var tokenFn = formatters[token];
        if (tokenFn) {
            result.push(tokenFn);
        }
        else if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']') {
            result.push(token.substring(1, token.length - 1));
        }
        else {
            result.push(token);
        }
    }
    return result;
}
function formatByTokens(d, tokens) {
    var result = [];
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        result.push(typeof token === 'function' ? token(d, i, tokens) : token);
    }
    return result.join('');
}
function createFormat(formatters) {
    var cache = {};
    return function (d, template) {
        if (!isValidDate(d))
            return null;
        var tokens = cache[template];
        if (tokens === undefined) {
            tokens = splitToTokens(template, formatters);
            cache[template] = tokens;
        }
        return formatByTokens(d, tokens);
    };
}
function createCustomFormatFn(formatters) {
    return function (customFormatters) {
        return createFormat(extend(formatters, customFormatters));
    };
}

function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function createParse(parsers) {
    var RX_TOKENS = /*@__PURE__*/ tokensRx(parsers);
    return function parse(dateStr, template) {
        var tokens = template.match(RX_TOKENS);
        // this regexp cant fail because of "|."
        var parsersFn = [];
        var rxStr = tokens
            .map(function (token) {
            var parser = parsers[token];
            if (parser) {
                parsersFn.push(parser[1]);
                var regexpPart = parser[0];
                return "(".concat(regexpPart, ")");
            }
            if (token.charAt(0) === '[' && token.charAt(token.length - 1) === ']')
                token = token.substring(1, token.length - 1);
            return escapeRegExp(token);
        })
            .join('');
        var rx = new RegExp('^' + rxStr + '$', 'i');
        var values = dateStr.match(rx);
        if (!values)
            return null;
        /* NOTE second zero needed to set current timezone */
        var date = new Date(2000, 0);
        values.slice(1).forEach(function (value, index) {
            var parserFn = parsersFn[index];
            parserFn(date, value);
        });
        return asValidDateOrNull(date);
    };
}
function parseOrThrowWrapper(fn) {
    return function parseOrThrow(dateStr, template) {
        var result = fn(dateStr, template);
        if (result === null)
            throw new Error("Failed to parse date \"".concat(dateStr, "\" by template \"").concat(template, "\""));
        return result;
    };
}

var defaultFormatters = {
    // Month: 1, 2, ..., 12
    M: function (date) { return date.getMonth() + 1; },
    // Month: 01, 02, ..., 12
    MM: function (date) { return leadZero(date.getMonth() + 1); },
    // Quarter: 1, 2, 3, 4
    Q: function (date) { return Math.ceil((date.getMonth() + 1) / 3); },
    // Day of month: 1, 2, ..., 31
    D: function (date) { return date.getDate(); },
    // Day of month: 01, 02, ..., 31
    DD: function (date) { return leadZero(date.getDate()); },
    // Day of year: 1, 2, ..., 366
    DDD: function (date) { return diffCalendarDate(date, resetYear(date)) + 1; },
    // Day of year: 001, 002, ..., 366
    DDDD: function (date) { return leadZero(defaultFormatters['DDD'](date), 3); },
    // Day of week: 0, 1, ..., 6
    d: function (date) { return date.getDay(); },
    // Day of ISO week: 1, 2, ..., 7
    E: function (date) { return date.getDay() || 7; },
    // ISO week: 1, 2, ..., 53
    W: function (date) {
        var isoYear = +defaultFormatters['GGGG'](date);
        var start = resetISOWeek(newValidDateOrThrow(isoYear, 0, 4));
        return Math.floor(diffCalendarDate(date, start) / 7) + 1;
    },
    // ISO week: 01, 02, ..., 53
    WW: function (date) { return leadZero(defaultFormatters['W'](date)); },
    // Year: 00, 01, ..., 99
    YY: function (date) { return date.getFullYear().toString().slice(-2); },
    // Year: 1900, 1901, ..., 2099
    YYYY: function (date) { return leadZero(date.getFullYear(), 4); },
    // ISO week-numbering year: 00, 01, ..., 99
    GG: function (date) { return defaultFormatters['GGGG'](date).toString().slice(-2); },
    // ISO week-numbering year: 1900, 1901, ..., 2099
    GGGG: function (date) {
        var startYear = date.getFullYear();
        var correction = date < resetISOWeek(newValidDateOrThrow(startYear, 0, 4))
            ? -1
            : date < resetISOWeek(newValidDateOrThrow(startYear + 1, 0, 4))
                ? 0
                : 1;
        return leadZero(startYear + correction, 4);
    },
    // Hour: 0, 1, ... 23
    H: function (date) { return date.getHours(); },
    // Hour: 00, 01, ..., 23
    HH: function (date) { return leadZero(date.getHours()); },
    // Hour: 1, 2, ..., 12
    h: function (date) { return date.getHours() % 12 || 12; },
    // Hour: 01, 02, ..., 12
    hh: function (date) { return leadZero(defaultFormatters['h'](date)); },
    // Minute: 0, 1, ..., 59
    m: function (date) { return date.getMinutes(); },
    // Minute: 00, 01, ..., 59
    mm: function (date) { return leadZero(date.getMinutes()); },
    // Second: 0, 1, ..., 59
    s: function (date) { return date.getSeconds(); },
    // Second: 00, 01, ..., 59
    ss: function (date) { return leadZero(date.getSeconds()); },
    // 1/10 of second: 0, 1, ..., 9
    S: function (date) { return Math.floor(date.getMilliseconds() / 100); },
    // 1/100 of second: 00, 01, ..., 99
    SS: function (date) { return leadZero(Math.floor(date.getMilliseconds() / 10)); },
    // Millisecond: 000, 001, ..., 999
    SSS: function (date) { return leadZero(date.getMilliseconds(), 3); },
    // Timezone: -01:00, +00:00, ... +12:00
    Z: function (date) { return formatTimezone(date.getTimezoneOffset(), ':'); },
    // Timezone: -0100, +0000, ... +1200
    ZZ: function (date) { return formatTimezone(date.getTimezoneOffset(), ''); },
    // Seconds timestamp: 512969520
    X: function (date) { return Math.floor(date.getTime() / 1000); },
    // Milliseconds timestamp: 512969520900
    x: function (date) { return date.getTime(); },
};

var rx1 = '\\d';
var rx2 = '\\d\\d';
var rx12 = '\\d\\d?';
var rx3 = '\\d{3}';
var rx4 = '\\d{4}';
var rxN = '\\d{5,}';
var defaultParsers = {
    // Month: 1, 2, ..., 12
    M: [
        rx12,
        function (date, value) {
            date.setMonth(+value - 1);
        },
    ],
    // Month: 01, 02, ..., 12
    MM: [
        rx2,
        function (date, value) {
            date.setMonth(+value - 1);
        },
    ],
    // Quarter: 1, 2, 3, 4
    // 'Q': (date, value) => Math.ceil((date.getMonth() + 1) / 3),
    // Day of month: 1, 2, ..., 31
    D: [
        rx12,
        function (date, value) {
            date.setDate(+value);
        },
    ],
    // Day of month: 01, 02, ..., 31
    DD: [
        rx2,
        function (date, value) {
            date.setDate(+value);
        },
    ],
    // Day of year: 1, 2, ..., 366
    // TODO 'DDD': (date, value) => getDayOfYear(date),
    // Day of year: 001, 002, ..., 366
    // TODO 'DDDD': (date, value) => leadZero(getDayOfYear(date), 3),
    // Day of week: 0, 1, ..., 6
    // 'd': (date, value) => date.getDay(),
    // Day of ISO week: 1, 2, ..., 7
    // 'E': (date, value) => date.getDay() || 7,
    // ISO week: 1, 2, ..., 53
    // TODO 'W': (date, value) => getISOWeek(date),
    // ISO week: 01, 02, ..., 53
    // TODO 'WW': (date, value) => leadZero(getISOWeek(date)),
    // Year: 00, 01, ..., 99
    YY: [
        rx2,
        function (date, value) {
            date.setFullYear(2000 + +value);
        },
    ],
    // Year: 1900, 1901, ..., 2099
    YYYY: [
        rx4,
        function (date, value) {
            date.setFullYear(+value);
        },
    ],
    // ISO week-numbering year: 00, 01, ..., 99
    // TODO 'GG': (date, value) => getISOYear(date).toString().slice(-2),
    // ISO week-numbering year: 1900, 1901, ..., 2099
    // TODO 'GGGG': (date, value) => getISOYear(date),
    // Hour: 0, 1, ... 23
    H: [
        rx12,
        function (date, value) {
            date.setHours(+value);
        },
    ],
    // Hour: 00, 01, ..., 23
    HH: [
        rx2,
        function (date, value) {
            date.setHours(+value);
        },
    ],
    // Hour: 1, 2, ..., 12
    //'h': (date, value) => (date.getHours() % 12) || 12,
    // Hour: 01, 02, ..., 12
    // 'hh': (date, value) => leadZero(formatters['h'](date)),
    // Minute: 0, 1, ..., 59
    m: [
        rx12,
        function (date, value) {
            date.setMinutes(+value);
        },
    ],
    // Minute: 00, 01, ..., 59
    mm: [
        rx2,
        function (date, value) {
            date.setMinutes(+value);
        },
    ],
    // Second: 0, 1, ..., 59
    s: [
        rx12,
        function (date, value) {
            date.setSeconds(+value);
        },
    ],
    // Second: 00, 01, ..., 59
    ss: [
        rx2,
        function (date, value) {
            date.setSeconds(+value);
        },
    ],
    // 1/10 of second: 0, 1, ..., 9
    S: [
        rx1,
        function (date, value) {
            date.setMilliseconds(+value * 100);
        },
    ],
    // 1/100 of second: 00, 01, ..., 99
    SS: [
        rx2,
        function (date, value) {
            date.setMilliseconds(+value * 10);
        },
    ],
    // Millisecond: 000, 001, ..., 999
    SSS: [
        rx3,
        function (date, value) {
            date.setMilliseconds(+value);
        },
    ],
    // Timezone: -01:00, +00:00, ... +12:00
    // TODO 'Z': (date, value) => formatTimezone(date.getTimezoneOffset(), ':'),
    // Timezone: -0100, +0000, ... +1200
    // TODO 'ZZ': (date, value) => formatTimezone(date.getTimezoneOffset()),
    // Seconds timestamp: 512969520
    X: [
        rxN,
        function (date, value) {
            date.setTime(+value * 1000);
        },
    ],
    // Milliseconds timestamp: 512969520900
    x: [
        rxN,
        function (date, value) {
            date.setTime(+value);
        },
    ],
};

export { diffMonth as A, diffYear as B, diffCalendarYear as C, diffCalendarMonth as D, diffCalendarDate as E, diffPreciseSeconds as F, diffPreciseMinutes as G, diffPreciseHours as H, diffPreciseDate as I, diffPreciseMonth as J, diffPreciseYear as K, formatDateIso as L, formatDateTimeIso as M, formatLocalIso as N, parseIso as O, parseIsoOrThrow as P, isValidDate as Q, fromDate as R, fromDateOrThrow as S, asValidDateOrNull as T, newValidDate as U, newValidDateOrThrow as V, createCustomFormatFn as a, createParse as b, createFormat as c, defaultFormatters as d, extend as e, defaultParsers as f, addMilliseconds as g, addSeconds as h, addMinutes as i, addHours as j, addDate as k, addMonth as l, addYear as m, resetMonth as n, resetISOWeek as o, parseOrThrowWrapper as p, resetDate as q, resetYear as r, resetHours as s, resetMinutes as t, resetSeconds as u, diffMilliseconds as v, diffSeconds as w, diffMinutes as x, diffHours as y, diffDate as z };
